import {common} from '@priority-software/priority-proto-api/lib';

export const createObjectURL = (fileData: common.IConstant) => {
    const content = new Uint8Array(fileData?.File?.Data);
    return URL.createObjectURL(
        new Blob([content.buffer], {type: fileData?.File?.MimeType + ';charset=utf8'})
    );
};

export const previewFile = (fileData: common.IConstant, fileName: string) => {
    if (fileData?.File?.MimeType) {
        const url = createObjectURL(fileData);
        window.open(url, '_blank');
    } else {
        downloadFile(fileData, fileName);
    }
};

export const downloadFile = (fileData: common.IConstant, fileName: string) => {
    const url = createObjectURL(fileData);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName + fileData?.File?.Extension;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
